/* tslint:disable */
/* eslint-disable */
/**
 * Bias Proof License API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum GroupStatus {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}

export function GroupStatusFromJSON(json: any): GroupStatus {
    return GroupStatusFromJSONTyped(json, false);
}

export function GroupStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupStatus {
    return json as GroupStatus;
}

export function GroupStatusToJSON(value?: GroupStatus | null): any {
    return value as any;
}

